export const CONJUGATION_EXAMPLE = {
  "verb": "tener",
  "definition": "to have",
  "conjugations": {
    "Indicative": {
      "Present": {
        "yo": "tengo",
        "tú/vos": "tienes",
        "él/ella/usted": "tiene",
        "nosotros/nosotras": "tenemos",
        "vosotros/vosotras": "tenéis",
        "ellos/ellas/ustedes": "tienen"
      },
      "Future": {
        "yo": "tendré",
        "tú/vos": "tendrás",
        "él/ella/usted": "tendrá",
        "nosotros/nosotras": "tendremos",
        "vosotros/vosotras": "tendréis",
        "ellos/ellas/ustedes": "tendrán"
      },
      "Imperfect": {
        "yo": "tenía",
        "tú/vos": "tenías",
        "él/ella/usted": "tenía",
        "nosotros/nosotras": "teníamos",
        "vosotros/vosotras": "teníais",
        "ellos/ellas/ustedes": "tenían"
      },
      "Preterite": {
        "yo": "tuve",
        "tú/vos": "tuviste",
        "él/ella/usted": "tuvo",
        "nosotros/nosotras": "tuvimos",
        "vosotros/vosotras": "tuvisteis",
        "ellos/ellas/ustedes": "tuvieron"
      },
      "Conditional": {
        "yo": "tendría",
        "tú/vos": "tendrías",
        "él/ella/usted": "tendría",
        "nosotros/nosotras": "tendríamos",
        "vosotros/vosotras": "tendríais",
        "ellos/ellas/ustedes": "tendrían"
      },
      "Present Perfect": {
        "yo": "he tenido",
        "tú/vos": "has tenido",
        "él/ella/usted": "ha tenido",
        "nosotros/nosotras": "hemos tenido",
        "vosotros/vosotras": "habéis tenido",
        "ellos/ellas/ustedes": "han tenido"
      },
      "Future Perfect": {
        "yo": "habré tenido",
        "tú/vos": "habrás tenido",
        "él/ella/usted": "habrá tenido",
        "nosotros/nosotras": "habremos tenido",
        "vosotros/vosotras": "habréis tenido",
        "ellos/ellas/ustedes": "habrán tenido"
      },
      "Past Perfect": {
        "yo": "había tenido",
        "tú/vos": "habías tenido",
        "él/ella/usted": "había tenido",
        "nosotros/nosotras": "habíamos tenido",
        "vosotros/vosotras": "habíais tenido",
        "ellos/ellas/ustedes": "habían tenido"
      },
      "Preterite (Archaic)": {
        "yo": "hube tenido",
        "tú/vos": "hubiste tenido",
        "él/ella/usted": "hubo tenido",
        "nosotros/nosotras": "hubimos tenido",
        "vosotros/vosotras": "hubisteis tenido",
        "ellos/ellas/ustedes": "hubieron tenido"
      },
      "Conditional Perfect": {
        "yo": "habría tenido",
        "tú/vos": "habrías tenido",
        "él/ella/usted": "habría tenido",
        "nosotros/nosotras": "habríamos tenido",
        "vosotros/vosotras": "habríais tenido",
        "ellos/ellas/ustedes": "habrían tenido"
      }
    },
    "Subjunctive": {
      "Present": {
        "yo": "tenga",
        "tú/vos": "tengas",
        "él/ella/usted": "tenga",
        "nosotros/nosotras": "tengamos",
        "vosotros/vosotras": "tengáis",
        "ellos/ellas/ustedes": "tengan"
      },
      "Imperfect": {
        "yo": "tuviera",
        "tú/vos": "tuvieras",
        "él/ella/usted": "tuviera",
        "nosotros/nosotras": "tuviéramos",
        "vosotros/vosotras": "tuvierais",
        "ellos/ellas/ustedes": "tuvieran"
      },
      "Future": {
        "yo": "tuviere",
        "tú/vos": "tuvieres",
        "él/ella/usted": "tuviere",
        "nosotros/nosotras": "tuviéremos",
        "vosotros/vosotras": "tuviereis",
        "ellos/ellas/ustedes": "tuvieren"
      },
      "Present Perfect": {
        "yo": "haya tenido",
        "tú/vos": "hayas tenido",
        "él/ella/usted": "haya tenido",
        "nosotros/nosotras": "hayamos tenido",
        "vosotros/vosotras": "hayáis tenido",
        "ellos/ellas/ustedes": "hayan tenido"
      },
      "Future Perfect": {
        "yo": "hubiere tenido",
        "tú/vos": "hubieres tenido",
        "él/ella/usted": "hubiere tenido",
        "nosotros/nosotras": "hubiéremos tenido",
        "vosotros/vosotras": "hubiereis tenido",
        "ellos/ellas/ustedes": "hubieren tenido"
      },
      "Past Perfect": {
        "yo": "hubiera tenido",
        "tú/vos": "hubieras tenido",
        "él/ella/usted": "hubiera tenido",
        "nosotros/nosotras": "hubiéramos tenido",
        "vosotros/vosotras": "hubierais tenido",
        "ellos/ellas/ustedes": "hubieran tenido"
      }
    },
    "Imperative Affirmative": {
      "Present": {
        "yo": "",
        "tú/vos": "ten",
        "él/ella/usted": "tened",
        "nosotros/nosotras": "",
        "vosotros/vosotras": "tenga",
        "ellos/ellas/ustedes": "tengan"
      }
    },
    "Imperative Negative": {
      "Present": {
        "yo": "",
        "tú/vos": "no tengas",
        "él/ella/usted": "no tengáis",
        "nosotros/nosotras": "",
        "vosotros/vosotras": "no tenga",
        "ellos/ellas/ustedes": "no tengan"
      }
    }
  }
};
